import { useJurisdictionStore } from '@/hooks/use-jurisdiction';

/**
 * Prismic product flag acting as a remote kill-switch for the AI match preview tabs.
 * Defaults to enabled when the flag is absent from the CMS.
 */
export const useMatchPreviewEnabled = () => {
    const matchPreviewPrismicFlag = useJurisdictionStore(
        store => store.jurisdictionSettings?.productConfig?.settings?.ai_match_preview_enabled
    );
    return matchPreviewPrismicFlag === true;
};
